<template>
	<div clss="question-script">
    	<EditorListQuestion v-if="mode=='editor'" />
		<Main v-else />
	</div>
</template>

<script>
import Main from './components/Main'
import EditorListQuestion from './components/EditorListQuestion'

export default {
  name: 'app',
  components: {
	Main,
	EditorListQuestion
  },
  computed: {
	  mode: function(){
		  return this.$store.getters.quiz.mode
	  }
  }
}
</script>

<style lang="scss">
* {
	margin: 0;
	padding: 0;
}

body {
	font-family: $fontFamily;
	color: #333;
	background: #dddddd;
	font-size: 15px;
}

.question-script {
	width: 100%;
	background-color: #fff;
}
</style>
